import React from 'react';
import PropTypes from 'prop-types';

import Checkbox from '../Checkbox';

import styles from './CheckboxWithLabel.module.scss';

const CheckboxWithLabel = props => {
  const { className, text, ...rest } = props;
  return (
    <div className={`${styles.checkboxWithLabel} ${className}`}>
      <Checkbox {...rest} />
      {rest.id ? (
        <label htmlFor={rest.id} className={styles.text}>
          {text}
        </label>
      ) : (
        <span className={styles.text}>{text}</span>
      )}
    </div>
  );
};

CheckboxWithLabel.propTypes = {
  className: PropTypes.string,
  text: PropTypes.string.isRequired,
  ...Checkbox.propTypes
};

CheckboxWithLabel.defaultProps = {
  className: '',
  ...Checkbox.defaultProps
};

export default CheckboxWithLabel;
